import { useEffect, useState } from 'react';

import { DecisionCounts, useDecisionsApi } from '../../../common/hooks/use-decisions-api.hook';

/**
 * How many decisions wait, for the Home entry. Null while unknown (or when
 * the inbox cannot be read): the entry then stays hidden rather than say 0.
 */
export function useDecisionCount(): DecisionCounts | null {
  const api = useDecisionsApi();
  const [counts, setCounts] = useState<DecisionCounts | null>(null);
  useEffect(() => {
    let alive = true;
    api.list()
      .then((r) => alive && setCounts(r.counts))
      .catch(() => alive && setCounts(null));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return counts;
}
